import { Routes } from '@angular/router';

import {
  singleBlogResolver,
  blogListResolver,
} from './blog-detail/blog.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./about/about.component').then((m) => m.AboutComponent),
    data: {
      seo: {
        title:
          'Digital Marketing & Web Development Agency in Goa — Serving Globally',
        siteNamePosition: 'prepend',
        description:
          'Grow your business with Geekeno, a Goa-based digital agency offering SEO, website development, and branding for India and international clients.',
        image: '/geekeno-og-image.png',
      },
    },
  },
  {
    path: 'services',
    children: [
      {
        path: 'digital-marketing',
        loadComponent: () =>
          import('./digital-marketing/digital-marketing.component').then(
            (m) => m.DigitalMarketingComponent,
          ),
        data: {
          seo: {
            title: 'Expert Digital Marketing & SEO Services in Goa and Beyond',
            description:
              "Boost your online presence with Geekeno's digital marketing services in Goa. SEO, PPC, and social media strategies for India and global brands.",
            image: '/geekeno-og-image.png',
          },
        },
      },
      {
        path: 'website-development',
        loadComponent: () =>
          import('./web-dev/web-dev.component').then((m) => m.WebDevComponent),
        data: {
          seo: {
            title:
              'Custom Website Design & Development Services — Goa to Global',
            description:
              'Geekeno builds fast, SEO-friendly, and responsive websites in Goa for clients worldwide. Specialized in WordPress, eCommerce, and custom apps.',
            image:
              '/assets/services/website-development/wordpress-ecommerce.webp',
          },
        },
      },
      {
        path: 'product-development',
        redirectTo: 'website-development',
        pathMatch: 'full',
      },
      {
        path: 'graphic-designing',
        loadComponent: () =>
          import('./graphic-designing/graphic-designing.component').then(
            (m) => m.GraphicDesigningComponent,
          ),
        data: {
          seo: {
            title:
              'Professional Graphic Design & Branding Agency in Goa & Globally',
            description:
              "Elevate your brand with Geekeno's graphic design services in Goa. Expert logo design, branding, and social media graphics for global reach.",
            image: '/geekeno-og-image.png',
          },
        },
      },
      {
        path: 'video-production',
        loadComponent: () =>
          import('./video-production/video-production.component').then(
            (m) => m.VideoProductionComponent,
          ),
        data: {
          seo: {
            title:
              'Video Production & Corporate Photography in Goa | Serving Globally',
            description:
              'Geekeno provides professional video production, editing, and corporate photography in Goa, helping brands tell stories through cinematic visuals.',
            image: '/geekeno-og-image.png',
          },
        },
      },
    ],
  },
  {
    path: 'blog',
    loadComponent: () =>
      import('./blog-list-page/blog-list-page.component').then(
        (m) => m.BlogListPageComponent,
      ),
    resolve: { initialBlogs: blogListResolver },
    data: {
      seo: {
        title: 'Digital Marketing, SEO & Branding Insights from Goa',
        description:
          'Read the latest blogs from Geekeno on digital marketing, SEO, web development, and branding trends in Goa and globally.',
        image: '/geekeno-og-image.png',
      },
    },
  },
  {
    path: 'blog/:slug',
    loadComponent: () =>
      import('./blog-detail/blog-detail.component').then(
        (m) => m.BlogDetailComponent,
      ),
    resolve: { blog: singleBlogResolver },
  },
  { path: 'about', redirectTo: '', pathMatch: 'full' },
  {
    path: 'products',
    children: [
      { path: 'brandkit', redirectTo: 'brand-kit', pathMatch: 'full' },
      {
        path: 'brand-kit',
        loadComponent: () =>
          import('./brandkit/brandkit.component').then(
            (m) => m.BrandkitComponent,
          ),
        data: {
          seo: {
            title:
              'Launch Your Personal Brand in 48 Hours with AI-Powered Kits',
            description:
              "Build your brand fast with Geekeno's AI-powered Brand Kit: custom logo, bio, and 15-post calendar delivered in 48 hours globally.",
            image: '/assets/products/brand-kit/standout-personal-brand.svg',
          },
        },
      },
      {
        path: 'rekavoze',
        loadComponent: () =>
          import('./rekavoze/rekavoze.component').then(
            (m) => m.RekavozeComponent,
          ),
        data: {
          seo: {
            title: 'Rekavoze — Smart Inventory & Expense Management for SMBs',
            description:
              'Manage inventory and expenses with Rekavoze, the intuitive dashboard built for small and growing businesses worldwide.',
            image: '/assets/products/rekavoze/inventory-logistics.svg',
          },
        },
      },
    ],
  },
  {
    path: 'policies',
    loadComponent: () =>
      import('./policies/policies.component').then((m) => m.PoliciesComponent),
    data: {
      seo: {
        title: 'Policies & Terms',
        description:
          'Explore the different policies and terms of service at Geekeno.',
        image: '/geekeno-og-image.png',
      },
    },
  },
  { path: '**', redirectTo: '' }, // todo: replace with 404
];
